// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__J9KwS","title":"header_title__gA+hp","wrapperLink":"header_wrapperLink__CjY9r"};